import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

function Authed({children}) {
    const isLoggedIn =useSelector(state=>state.LoginReducer.token)
    if(!isLoggedIn){
      return <Navigate to='/login'/>
    }
    return children
}

export default Authed